<template>
  <div class="secondary-nav">
    <div class="nav-icon-init" @click="show= !show">&#9776;</div>

    <div class="overlay" :class="{'show-overlay' : show}">
      <div class="overlay-content">
        <a href="#"> products</a>
        <a class="active" href="#"> clients</a>
        <a href="#">contact </a>
        <a href="#">about </a>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: "SecondaryNav",

    data() {
      return {
        show: false
      }
    }
  }
</script>

<style lang="scss">
  @import "SecondaryNav";
</style>
